import { FC } from 'react';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import FacebookReportPreviewSections from './sections/FacebookReportPreviewSections';
import GeneralReportPreviewSections from './sections/GeneralReportPreviewSections';
import InstagramReportPreviewSections from './sections/InstagramReportPreviewSections';
import LinkedInReportPreviewSections from './sections/LinkedInReportPreviewSections';
import TikTokReportPreviewSections from './sections/TikTokReportPreviewSections';
import DefaultReportPreviewSections from './sections/DefaultReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from './types/ReportProfilePreviewSectionsProps';

export const REPORT_PROFILE_PREVIEW_SECTIONS: Partial<
  Record<number | 'general', FC<ReportProfilePreviewSectionsProps>>
> = {
  general: GeneralReportPreviewSections,
  [TYPE.FACEBOOK]: FacebookReportPreviewSections,
  [TYPE.FACEBOOK_AD]: FacebookReportPreviewSections,
  [TYPE.INSTAGRAM]: InstagramReportPreviewSections,
  [TYPE.LINKEDIN]: LinkedInReportPreviewSections,
  [TYPE.TIKTOK]: TikTokReportPreviewSections,
};

export function resolveReportProfilePreviewSections(
  cardType: 'general' | 'profile',
  pageType?: number,
): FC<ReportProfilePreviewSectionsProps> {
  if (cardType === 'general') {
    return (
      REPORT_PROFILE_PREVIEW_SECTIONS.general ?? DefaultReportPreviewSections
    );
  }

  if (pageType != null && REPORT_PROFILE_PREVIEW_SECTIONS[pageType]) {
    return REPORT_PROFILE_PREVIEW_SECTIONS[pageType]!;
  }

  return DefaultReportPreviewSections;
}
